<template>
  <div class="productpage__wrapper" itemtype="https://schema.org/Product">
    <product-image-container
      :gallery-items="galleryItems"
      :mockups="mockups"
      :store="store"
      :sku="product.sku"
    />

    <div
      id="product-description"
      :data-sku="product.sku"
      class="productpage__details"
    >
      <slot></slot>
      <h1 class="product-title" itemprop="name">
        {{ productNameWithDevice }}
      </h1>
      <div id="cart-form">
        <product-form
          :product="product"
          :product-stock="productStock"
          :line-item-editor="lineItemEditor"
          :item-editor="itemEditor"
          :line-item-id="lineItemId"
          :is-gift="isGift"
          :my-order-number="myOrderNumber"
          :permitted-case-type-ids="permittedCaseTypeIds"
          :permitted-device-ids="permittedDeviceIds"
          :customplace-item="customplaceItem"
          :editable-order-product="editableOrderProduct"
          @updateItemProduct="
            (itemProduct) =>
              $emit('updateItemProduct', {
                code: currentItemCode,
                ...itemProduct,
              })
          "
          @productFormLoaded="$emit('productFormLoaded')"
          @updatedLineItem="$emit('updatedLineItem')"
          @updateProductType="updateProductType"
          @updateDescription="updateDescription"
          @updateDeviceName="updateDeviceName"
          @displayPrice="displayPrice"
          @error="(err) => handleError(err, true)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import ProductForm from '~/components/product/form/product-form'
import errorHandler from '~/mixins/error-handler'
import namelableDevice from '~/mixins/namelable-device'
import mockup from '~/mixins/mockup/mockup.js'
import ProductImageContainer from '~/components/product/product-editor/product-image-container/ProductImageContainer.vue'

export default {
  components: {
    ProductForm,
    ProductImageContainer,
  },
  mixins: [errorHandler, namelableDevice, mockup],
  props: {
    permittedDeviceIds: {
      type: String,
      default: null,
    },
    itemEditor: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
    productStock: {
      type: Object,
      required: true,
    },
    customplaceItem: {
      type: Object,
      default: null,
    },
    galleryItems: {
      type: [Array, Object],
      required: true,
    },
    lineItemEditor: {
      type: Boolean,
      default: false,
    },
    lineItemId: {
      type: Number,
      default: null,
    },
    isGift: {
      type: Boolean,
      default: false,
    },
    myOrderNumber: {
      type: [Number, String],
      default: null,
    },
    currentItemCode: {
      type: String,
      default: null,
    },
    permittedCaseTypeIds: {
      type: Array,
      default: () => [],
    },
    editableOrderProduct: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    store() {
      return this.$store.state.storeCode
    },
    mockups() {
      // Mixins: Method imported from mockup mixin
      return this.getArrayFromProduct(this.product)
    },
  },
  methods: {
    displayPrice(price) {
      this.$emit('displayPrice', price)
    },
    updateDeviceName(deviceName) {
      this.$emit('updateDeviceName', deviceName)
    },
    updateProductType(productType) {
      this.$emit('updateProductType', productType)
    },
    updateDescription(description) {
      this.$emit('updateDescription', description)
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/pretty-select.scss';
@import '~/assets/css/image-select.scss';
@import '~/assets/css/composite-device-selector.scss';
@import '~/assets/css/productpage.scss';
@import '~/assets/css/product-price.scss';
</style>
